import { Cache } from "@siteimprove/alfa-cache";
import { Device } from "@siteimprove/alfa-device";
import { Document } from "@siteimprove/alfa-dom";
import { Decoder } from "@siteimprove/alfa-encoding";
import { Request, Response } from "@siteimprove/alfa-http";
/**
 * {@link https://en.wikipedia.org/wiki/Web_page}
 *
 * @public
 */
export class Page {
    static of(request, response, document, device) {
        return new Page(request, response, document, device);
    }
    _request;
    _response;
    _document;
    _device;
    constructor(request, response, document, device) {
        this._request = request;
        this._response = response;
        this._document = document;
        this._device = device;
    }
    get request() {
        return this._request;
    }
    get response() {
        return this._response;
    }
    get document() {
        return this._document;
    }
    get device() {
        return this._device;
    }
    toJSON(options) {
        return {
            request: this._request.toJSON(options),
            response: this._response.toJSON(options),
            document: this._document.toJSON({
                device: this._device,
                ...(options ?? {}),
            }),
            device: this._device.toJSON(options),
        };
    }
    toEARL() {
        return {
            "@context": {
                earl: "http://www.w3.org/ns/earl#",
                dct: "http://purl.org/dc/terms/",
            },
            "@type": ["earl:TestSubject"],
            "@id": this.response.url.toString(),
            "dct:source": this.response.url.toString(),
            "dct:hasPart": [this._request.toEARL(), this._response.toEARL()],
        };
    }
    toSARIF() {
        return {
            location: {
                uri: this.response.url.toString(),
            },
            contents: {
                text: Decoder.decode(new Uint8Array(this.response.body)),
            },
        };
    }
}
/**
 * @public
 */
(function (Page) {
    const cache = Cache.empty();
    function from(json) {
        return cache.get(json, () => {
            const device = Device.from(json.device);
            return Request.from(json.request).andThen((request) => Response.from(json.response).map((response) => Page.of(request, response, Document.from(json.document, device), device)));
        });
    }
    Page.from = from;
    function isPage(value) {
        return value instanceof Page;
    }
    Page.isPage = isPage;
})(Page || (Page = {}));
//# sourceMappingURL=page.js.map